import { useI18n } from '@change-corgi/core/react/i18n';

type Result = {
	label: string;
};

export function useSubmitButton({ loading }: { loading: boolean }): Result {
	const { translate } = useI18n();

	return {
		label: loading
			? translate('corgi.co.promote.payment_type_button.processing_payment')
			: translate('corgi.co.promote.payment_type_button.pay_securely'),
	};
}
